import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';
import { ConsolidationSummaryType } from '@/features/dashboard/types';

async function getTermometroGeralDetalhes(id): Promise<ConsolidationSummaryType> {
  const api = await getApi();
  const { data } = await api.get<ConsolidationSummaryType>(`/termometro/geral/detalhes_aluno/?student_id=${id}`, {});
  return data;
}

type QueryFnType = typeof getTermometroGeralDetalhes;

function useTermometroGeralDetalhes(id) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['termometro-geral-detalhes', id],
    queryFn: () => getTermometroGeralDetalhes(id),
  });
}

export { getTermometroGeralDetalhes, useTermometroGeralDetalhes };
